export default __webpack_public_path__ + "static/media/banner.eb90fce5.png";